import { gridTpl } from '../../../../../../../../common/grid/grid.controller';

export const administrationAccountsLicenceSiteLocationsGrid = {
    bindings: {
        title: '<'
    },
    controller: 'AdministrationAccountsLicenceSiteLocationsGridController',
    ...gridTpl
};
